<template>
  <v-container fluid>
    <v-btn color="primary" to="/settings/areas/new">새 구역 만들기</v-btn>
    <v-data-table
    :items="items"
    :loading="loading"
    :headers="headers"
    class="text-no-wrap">
      <template v-slot:item.edit="{ item }">
        <v-btn icon :to="getEditPath(item._id)"><v-icon>mdi-cog</v-icon></v-btn>
        <v-btn icon @click="remove(item)"><v-icon>mdi-delete</v-icon></v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { getAreaList, removeArea } from '@/api'
// import get from 'lodash/get'
export default {
  data () {
    return {
      areas: [],
      headers: [
        {
          text: '구역명',
          value: 'name'
        },
        {
          text: '주소',
          value: 'address'
        },
        {
          text: '편집',
          value: 'edit'
        }
      ],
      loading: false
    }
  },
  computed: {
    items () {
      return this.areas.map(area => {
        return {
          _id: area._id,
          address: area.address,
          name: area.name
        }
      })
    }
  },
  created () {
    this.getchAreas()
  },
  methods: {
    async getchAreas () {
      this.loading = true
      try {
        const query = {}
        const { idleareas: areas } = await getAreaList(null, query)

        this.areas = areas
      } catch (err) {
        console.error(err)
      }
      this.loading = false
    },
    getEditPath (_id) {
      return `/settings/areas/edit/${_id}`
    },
    async remove (item) {
      if (!confirm(`${item.name} 을 정말 삭제하시겠습니까?`)) return

      const _id = item._id

      try {
        await removeArea(_id)
        this.getchAreas()
      } catch (err) {
        alert(err.message)
      }
    }
  }
}
</script>
